/* eslint-disable */
/* Code generated by generate-angular-formgroups.mjs DO NOT EDIT. */
import { signal, WritableSignal } from '@angular/core';
import { form, minLength, required, SchemaPathTree } from '@angular/forms/signals';
import { LexplusVerifyOtpDto } from '../models';

/** Initial value for the signal model. */
export function getLexplusVerifyOtpDtoInitialValue(): LexplusVerifyOtpDto {
  return {
  otp: '',
  email: '',
  userId: '',
  appDeviceId: '',
  angemeldetBleiben: false,
} as LexplusVerifyOtpDto;
}

/**
 * Reusable Signal Forms schema for LexplusVerifyOtpDto.
 * Can be passed to form() directly or embedded via apply()/applyEach().
 */
export function lexplusVerifyOtpDtoSchema(path: SchemaPathTree<LexplusVerifyOtpDto>): void {
  required(path.otp);
  minLength(path.otp, 6);
  required(path.email);
  required(path.userId);
}

/**
 * Creates the model signal and the form in one call.
 * The model signal is needed for submit(), for example: submit(field, { action }).
 */
export function createLexplusVerifyOtpDtoForm(initial?: Partial<LexplusVerifyOtpDto>) {
  const model: WritableSignal<LexplusVerifyOtpDto> = signal<LexplusVerifyOtpDto>({
    ...getLexplusVerifyOtpDtoInitialValue(),
    ...initial,
  } as LexplusVerifyOtpDto);
  return { model, field: form(model, lexplusVerifyOtpDtoSchema) };
}
